import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthRoutingModule } from './auth-routing.module';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

import { LoginComponent } from './login/login.component';

import { FlexLayoutModule } from "@angular/flex-layout";

import {AuthService} from "../_services/auth.service"
import { HttpClientModule } from '@angular/common/http';
import { LogoutComponent } from './logout/logout.component';
import { CommonsModule } from '../commons/commons.module';
import { SignupComponent } from './signup/signup.component';
import { ConfirmEmailComponent } from './confirm-email/confirm-email.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { SetNewPasswordComponent } from './set-new-password/set-new-password.component';
import { ResetVaPasswordComponent } from './reset-va-password/reset-va-password.component'
import { CommonService } from '../_services/common.service';
import { PasswordValidator } from '../_directives/password-validator/password-validator.directive';

@NgModule({
  imports: [
    CommonModule,
    NgbModule,
    AuthRoutingModule,
    FlexLayoutModule,
    CommonsModule,
  ],
  declarations: [LoginComponent, LogoutComponent, SignupComponent, ConfirmEmailComponent,ForgotPasswordComponent, SetNewPasswordComponent, ResetVaPasswordComponent],
  providers:[HttpClientModule,CommonService],
  exports: [ ]
})
export class AuthModule { }
